<template>
  <nna-container>
    <div class="align-middle">    
      <h1 class="md-title">Verifica Account</h1>
      <!--<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>-->
      <form novalidate class="md-layout" @submit.prevent="onSubmitForm">
        <md-field :class="getValidationClass('code')">
          <label for="code">codice di verifica</label>
          <md-input name="code" id="code" autocomplete="name" v-model="form.code" :disabled="sending" />
          <span class="md-error" v-if="!$v.form.code.required">Inserisci il codice di verifica</span>
        </md-field>
        <md-button type="submit" class="md-raised md-primary" md-align="center">Verifica Account</md-button>
      </form>
    </div>
  </nna-container> 
</template>

<script>
import CMM from '@nonameapp-core'
import { mapActions } from 'vuex'
export default {
  name: 'VerifyNumber',
  mixins: [
    CMM._mixins.form("verifyNumber")
  ],
  data() {
    return {
      form: {
        code: null
      }
    }
  },
  methods: {
    ...mapActions({
      verifyPhoneNumber: "auth/verifyPhoneNumber",
    }),
    onSubmitForm () {
      if(this.validateForm()) this.verify()
    },    
    async verify() {
      let username = this.$route.params.username
      if(username) {
        try { 
          const { data } = await this.verifyPhoneNumber({ username: username, code: this.form.code })
          if(data.hcode === "ok") {
            this.sending = false
            this.$toasted.show("Utente registrato", { type: 'success' })
            this.$router.push({ name: "signup.done" })
            this.clearForm()            
          } else {
            this.sending = false
            this.$toasted.show(data.msg, { type: 'error' })
          }        
        } catch (errors) {
          console.error("Error:", errors)
          this.sending = false
          this.$toasted.show('Qualcosa è andato storto!', { type: 'error' })
          }              
      }
    }
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/modules/auth/signup/pages/VerifyNumber.vue